import {
  Box,
  Card,
  CardBody,
  Tab,
  TabList,
  TabPanels,
  Tabs,
  TabPanel,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import Completed from "./components/Completed";
import Waiting from "./components/Waiting";
import InProgress from "./components/InProgress";
import { useDispatch } from "react-redux";
import { addTaskData } from "../../../redux/TaskSlice";
import { addUserData } from "../../../redux/UserSlice";
import { addDepartmentData } from "../../../redux/DepartmentSlice";
import { addCustomerData } from "../../../redux/CustomerSlice";
import { TaskService } from "../../../core/Services";
import { BreadCrumb } from "primereact/breadcrumb";
import { ARCHIVE_MODE_ENABLED } from "../../../archive/archiveConfig";

export default function TasksPage() {
  const dispatch = useDispatch();
  useEffect(() => {
    const fetchData = async () => {
      try {
        const taskData = await TaskService();
        
        // Güncellenmiş veriyi Redux store'a ekle
        dispatch(addTaskData(taskData.tasks));
        dispatch(addUserData(taskData.users));
        dispatch(addDepartmentData(taskData.departments));
        dispatch(addCustomerData(taskData.customers));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, [dispatch]);

  const getTurkishLabel = (url) => {
    switch (url) {
      case "/tasks":
        return "Görevler";
      // Diğer durumlar için gerektiğinde eşleme yapabilirsiniz
      default:
        return "Sayfa"; // Varsayılan olarak "Sayfa" kullanılabilir veya istediğiniz bir şeyi kullanabilirsiniz
    }
  };
  const url = "/tasks";
  const turkishLabel = getTurkishLabel(url); // "Ürünler"

  const itemsBread = [{ label: turkishLabel, url: url }];
  const home = { icon: "pi pi-home", url: "/dashboard" };
  // hidedialog calısırken calısan bir state yaz yeni
  return (
    <Box mt="5">
      <Card>
        <BreadCrumb
          model={itemsBread}
          home={home}
          style={{ padding: "1rem" }}
        />
        <CardBody>
          {ARCHIVE_MODE_ENABLED ? (
            <>
              <Completed />
              <InProgress />
            </>
          ) : (
            <Tabs align="end" variant="enclosed" defaultIndex={0}>
              <TabList>
                <Tab>İşlemde</Tab>
                <Tab>Bekleyen</Tab>
                <Tab>Tamamlanan</Tab>
              </TabList>
              <TabPanels>
                <TabPanel>
                  <InProgress />
                </TabPanel>
                <TabPanel>
                  <Waiting />
                </TabPanel>
                <TabPanel>
                  <Completed />
                </TabPanel>
              </TabPanels>
            </Tabs>
          )}
        </CardBody>
      </Card>
    </Box>
  );
}
